var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list.value, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "channelId", label: "渠道" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(`[${scope.row.channelId}] `) +
                          " " +
                          _vm._s(scope.row.channelName)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "clientType", label: "端类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.clientType == "1"
                      ? _c("span", [_vm._v("发端")])
                      : _vm._e(),
                    scope.row.clientType == "2"
                      ? _c("span", [_vm._v("收端")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "label", label: "标签" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.label == 1
                      ? _c("span", [_vm._v("白名单")])
                      : _vm._e(),
                    scope.row.label == 2
                      ? _c("span", [_vm._v("灰名单")])
                      : _vm._e(),
                    scope.row.label == 3
                      ? _c("span", [_vm._v("黑名单")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createBy", label: "创建人" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateBy", label: "修改人" },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "更新时间" },
          }),
          _c("el-table-column", { attrs: { prop: "remark", label: "备注" } }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "SECURITY_MANAGE_CHANNEL_MANAGE_EDIT",
                            expression: "'SECURITY_MANAGE_CHANNEL_MANAGE_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "SECURITY_MANAGE_CHANNEL_MANAGE_DEL",
                            expression: "'SECURITY_MANAGE_CHANNEL_MANAGE_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.del(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          total: _vm.searchParams.total,
          current: _vm.searchParams.current,
          size: _vm.searchParams.size,
          pageSizes: [10, 20, 50, 100],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("Add", { ref: "add" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }